exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".landscape-photo-container {\n  position: relative;\n}\n.landscape-photo-container .landscape-photo {\n  height: 80px;\n  background-color: #ccc;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n}\n.portrait-photo-container {\n  position: relative;\n  margin-top: -50px;\n  transition: margin-top 0.3s;\n}\n.portrait-photo .profile-img {\n  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.36);\n}\n.agent-photo-card:hover .portrait-photo-container {\n  margin-top: 30px;\n}", ""]);

// exports
